import axios from "../../../util/axios";

export default {
    /** 查询订单列表 */
    queryQywxOrderList: (data) => axios.get({url: "/wx/merchant/qywxOrder/queryQywxOrderList", data}),
    /** 查询订单详情 */
    findById: (id) => axios.get({url: "/wx/merchant/qywxOrder/findById", data: {id}}),
    /** 添加一个订单 */
    sendApply: (data) => axios.post({url: "/wx/merchant/qywxOrder/sendApply", data}),
    /** 激活账号 */
    activeAccount: (data) => axios.get({url: "/wx/merchant/qywxOrder/activeAccount", data}),
}